const FOCUSABLE_SELECTOR =
	'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

document.querySelectorAll<HTMLDialogElement>('dialog.lightbox').forEach(dialog => {
	const images = Array.from(dialog.querySelectorAll<HTMLImageElement>('.images img'))
	const closeButton = dialog.querySelector<HTMLButtonElement>('.close')
	const status = dialog.querySelector<HTMLElement>('[data-lightbox-status]')
	let lastFocused: HTMLElement | null = null

	const section = dialog.closest('section')
	const triggers = Array.from(
		(section ?? document).querySelectorAll<HTMLElement>('[data-open-lightbox]'),
	)

	const show = (imgId: string) => {
		const target = images.find(img => img.getAttribute('data-id') === imgId)
		if (!target) return

		images.forEach(img => img.classList.remove('showing'))
		target.classList.add('showing')

		lastFocused = document.activeElement as HTMLElement | null
		dialog.showModal()
		closeButton?.focus()

		if (status) {
			const index = images.indexOf(target) + 1
			status.textContent = `Image ${index} of ${images.length}: ${target.alt}`
		}
	}

	const close = () => {
		dialog.close()
	}

	triggers.forEach(trigger => {
		const open = () => show(trigger.getAttribute('data-open-lightbox') ?? '')

		trigger.addEventListener('click', open)
		trigger.addEventListener('keydown', event => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				open()
			}
		})
	})

	closeButton?.addEventListener('click', close)

	dialog.addEventListener('click', event => {
		if (event.target === dialog) close()
	})

	dialog.addEventListener('close', () => {
		images.forEach(img => img.classList.remove('showing'))
		if (status) status.textContent = ''
		lastFocused?.focus()
	})

	dialog.addEventListener('keydown', event => {
		if (event.key !== 'Tab') return

		const focusable = Array.from(
			dialog.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR),
		).filter(el => el.offsetParent !== null)
		if (!focusable.length) return

		const first = focusable[0]
		const last = focusable[focusable.length - 1]

		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault()
			last.focus()
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault()
			first.focus()
		}
	})
})
